import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from "react";

/** MATERIAL REACT TABLE */
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';

/** MUI */
import {
    Box,
    Button
} from "@mui/material";

/** MUI ICONS */
import FileDownloadIcon from '@mui/icons-material/FileDownload';

/** SERVICIOS */
import causalService from "../services/causal.service";

import FileSaver from "file-saver";
import * as XLSX from "xlsx";

const PanelCompleto = () => {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [causales, setCausales] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        //retreiveCasuales(pagination.pageIndex, pagination.pageSize);
        retreiveAllCausals();
    }, []); //pagination.pageIndex, pagination.pageSize

    function retreiveCasuales(page, size) {
        setLoading(true);
        causalService.getAllPages(page, size)
            .then(resp => {
                console.log(resp.data);
                setCausales(resp.data.causales);
                setRowCount(resp.data.totalItems);
                setLoading(false);
            }).catch(error => {
                console.error(error);
                setLoading(false);
            });
    };

    function retreiveAllCausals() {
        setLoading(true);
        var temp = [];
        causalService.getAll()
            .then(resp => {
                //setCausales(resp.data);
                const data = resp.data;
                var cantidad = data.length;
                console.log(cantidad);
                data.map((d) => {
                    const data_temp = {
                        rut: d.persona?.Rut,
                        nombre: d.persona?.perNombre1 + " " + d.persona?.perNombre2 + " " + d.persona?.perApPaterno + " " + d.persona?.perApMaterno,
                        causal: d.descripcion,
                        evaluacion: d.evaluacion,
                        unidad_negocio: d.persona?.ctoDescripcion,
                        cargo: d.persona?.recDescripcion,
                        estado_solicitud: d.persona?.estado_desv,
                        fecha_ingreso: moment(d.fecha_ingreso).utc().format("DD-MM-YYYY")
                    }
                    temp.push(data_temp);
                })
                setCausales(temp);
                setLoading(false);
            }).catch(error => {
                console.log(error);
                setLoading(false);
            })
    }

    /* const columns = useMemo(
        () => [
            {
                accessorKey: 'descripcion',
                header: 'Descripción',
            }
        ],
        //[],
    ); */

    const columns = useMemo(
        () => [{
            id: 'causal',
            header: 'Panel Seguimiento Solicitud de Desvinculación',
            columns: [
                {
                    accessorKey: 'rut',
                    header: 'Rut',
                },
                {
                    accessorKey: 'nombre',
                    header: 'Nombre',
                    Cell: ({ cell, row }) => (
                        `${cell.getValue()}`
                    )
                },
                {
                    accessorKey: 'causal',
                    header: 'Causal',
                },
                {
                    accessorKey: 'evaluacion',
                    header: 'Evaluación',
                },
                {
                    accessorKey: 'unidad_negocio',
                    header: 'Unidad de Negocio',
                },
                {
                    accessorKey: 'cargo',
                    header: 'Cargo',
                },
                {
                    accessorKey: 'estado_solicitud',
                    header: 'Estado de Solicitud',
                },
                {
                    accessorKey: 'fecha_ingreso',
                    header: 'Fecha Ingreso Solicitud',
                    /* Cell: ({ cell }) => (
                        moment(cell.getValue()).utc().format("DD-MM-YYYY")
                    ) */
                },
            ]
        }]
    );

    const handleColumnFilterChante = (old) => {
        console.log(old.column);
    }

    const table = useMaterialReactTable({
        columns,
        data: causales ? causales : [],
        //manualPagination: true,
        //onPaginationChange: setPagination, //hoist pagination state to your state when it changes internally
        state: { isLoading: loading }, //pass the pagination state to the table pagination
        //rowCount: rowCount,
        localization: MRT_Localization_ES,
        enableStickyHeader: true,
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        exportData(table.getPrePaginationRowModel().rows)
                    }
                    startIcon={<FileDownloadIcon />}
                >
                    Exportar Todos
                </Button>
            </Box>
        ),
    });

    function getValue(object, path) {
        return path.
            replace(/\[/g, '.').
            replace(/\]/g, '').
            split('.').
            reduce((o, k) => (o || {})[k], object);
    }

    const exportData = (rows) => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";

        const tableData = rows.map((row) => {
            columns.map((column) => _.get(row.original, column.accessorKey));
        });

        //console.log(tableData);

        const dataWithHeaders = rows.map((row) => {
            ;
            const obj = {};
            columns
                .forEach((column) => {
                    column.columns.filter((col) => col.header)
                        .forEach((col) => {
                            //console.log(col);
                            console.log(_.get(row.original, col.accessorKey));
                            if (col.header) obj[col.header] = _.get(row.original, col.accessorKey);
                        })
                    //column.columns.forEach((col)=>console.log(col.header));
                })
            /* .filter((column) => column.headerName)
            .forEach((column) => {
                console.log(column);
                if (column.headerName) obj[column.headerName] = row[column.field];
            }); */
            return obj;
        });

        //console.log(dataWithHeaders);

        const ws = XLSX.utils.json_to_sheet(dataWithHeaders);

        // Create workbook and add sheet with data
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

        // Write workbook to buffer in xlsx format
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Convert buffer to Blob with specified MIME type
        const data = new Blob([excelBuffer], { type: fileType });

        // Save data as a file with specified filename
        FileSaver.saveAs(data, "Desvinculados" + fileExtension);
    }

    return (

        <Box sx={{
            margin: 3,
            width: "100%"
        }}>
            <MaterialReactTable
                table={table}
            />;
        </Box>

    )
}

export default PanelCompleto;